import { render } from "./IconUserImage.vue?vue&type=template&id=42c947d8&scoped=true&ts=true"
import script from "./IconUserImage.vue?vue&type=script&lang=ts"
export * from "./IconUserImage.vue?vue&type=script&lang=ts"

import "./IconUserImage.vue?vue&type=style&index=0&id=42c947d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c947d8"]])

export default __exports__